import React, { Component, PropTypes } from 'react';
import { LoadingIndicator } from 'common/components/preloader';
import 'pdfjs-dist';
import PDF, { Page } from 'react-pdf-pages';
PDFJS.workerSrc = require('file-loader!pdfjs-dist/build/pdf.worker.min.js');

/**
 * Component that loads and displays a PDF given its URL.
 * @author Nathan Ozelim <nathan@startupfoundry.com>
 */
export default class Pdf extends Component {
  constructor(props) {
    super(props)
    this.state = {pages: null, error: ''}
    this.renderContent = this.renderContent.bind(this)
    this.onComplete = this.onComplete.bind(this)
  }

  renderContent() {
    const {error, pages} = this.state

    if (error) {
      return <div className="text-danger">{error}</div>
    }

    if (!pages) {
      return <LoadingIndicator />
    }

    return pages.map((page) => <Page key={page.key} page={page} />)
  }

  onComplete(pages) {
    this.setState({pages, error: ''})
  }

  render() {
    const { url } = this.props

    if (!url) {
      return <LoadingIndicator fullScreen={false} />;
    }

    return (
      <div className="pdf">
        <PDF url={url} onComplete={this.onComplete}/>
        { this.renderContent() }
      </div>
    )
  }
}

/**
 * PropTypes.
 *
 * @property {string} url  - PDF's url
 *
 */
Pdf.propTypes = {
  url: PropTypes.string
};



// WEBPACK FOOTER //
// ./common/components/pdf.jsx